<template>
  <div class="noticeMain" v-loading="loading">
    <div class="year" v-for="year in lists" :key="year.year">
      <h1 style="margin: 0">{{ year.year }}</h1>
      <el-timeline>
        <el-timeline-item v-for="item in year.arr" :key="item.id" :timestamp="item.cDate" hide-timestamp center placement="top" :color="item.readCount == 0 ? '#F17F60' : '#E4E7ED'">
          <div class="timeStamp">
            <p>{{ item.cDate.substring(5, 10) }}</p>
            <p>{{ item.cDate.substring(11, 16) }}</p>
          </div>
          <el-card>
            <template #header>
              <span>系统更新</span>
              <el-link @click="onClick(item)">了解详情</el-link>
            </template>
            <span>{{ item.cTitle }}</span>
          </el-card>
        </el-timeline-item>
      </el-timeline>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { useNoticeMain } from "./useNotice";
import { GetUserMessageListResponse } from "@/api/noticeApi/noticeLimit";
import noticeApi from "@/api/noticeApi/noticeApi";

const { lists, loading, getUserMessageList } = useNoticeMain();

defineExpose({
  getUserMessageList,
});

const emits = defineEmits<{
  (e: "details", item: GetUserMessageListResponse): void;
}>();

const onClick = async (item: GetUserMessageListResponse) => {
  // const params = {
  //   cnoticeid: item.cNoticesID,
  // };
  // await noticeApi.AddUserKnowMsgLog(params);
  emits("details", item);
};
</script>
<style lang="less" scope>
@width: 100px;
.el-timeline {
  // padding-left: @width;
  padding-left: 50px;
  position: relative;
  .timeStamp {
    // position: absolute;
    // left: -@width;
    // width: 100px;
    // line-height: 1;
    // font-size: 14px;
    // color: #333;
    position: absolute;
    left: -50px;
    width: 50px;
    line-height: 10px;
    font-size: 13px;
    color: #333;
    top: 15px;
  }
  .el-timeline-item {
    padding-bottom: 35px;
    .el-timeline-item__wrapper {
      top: 3px;
    }
  }
}
.el-card {
  .el-card__header {
    background: #f7f8fc;
    line-height: 25px;

    .el-link {
      --el-text-color-regular: #ee816e;
      white-space: nowrap;
      margin: 0 20px;
      --el-link-hover-text-color: #ee816e;
      float: right;
    }
  }
  .el-card__body {
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: normal;
    padding-bottom: 20px;
  }
}
</style>
